import { render, staticRenderFns } from "./XhSelect.vue?vue&type=template&id=4cb70346&scoped=true"
import script from "./XhSelect.vue?vue&type=script&lang=js"
export * from "./XhSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb70346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb70346')) {
      api.createRecord('4cb70346', component.options)
    } else {
      api.reload('4cb70346', component.options)
    }
    module.hot.accept("./XhSelect.vue?vue&type=template&id=4cb70346&scoped=true", function () {
      api.rerender('4cb70346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhSelect.vue"
export default component.exports